export enum ReferralStatus {
  Pending = 0,
  Active = 1,
  Claimed = 2
}
